import React from 'react';
import { Coins, Star } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const PlayerStats = ({ playerStats, isMobile }) => {
    const { theme } = useTheme();

    if (!playerStats) return null;

    return (
        <div style={{
            backgroundColor: theme.cardBg,
            animation: 'bubbleAppear 0.5s ease-in-out',
            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
            minHeight: isMobile ? '100px' : '120px',
            marginBottom: isMobile ? '24px' : '34px',
            borderRadius: '5px',
            padding: isMobile ? '17px' : '26px'
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: isMobile ? '17px' : '34px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '17px'
                }}>
                    <Coins size={isMobile ? 40 : 50} style={{ color: theme.text }} />
                    <div>
                        <div style={{
                            fontSize: isMobile ? '16px' : '18px',
                            color: theme.text,
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                        }}>
                            Balance
                        </div>
                        <div style={{
                            fontSize: isMobile ? '28px' : '36px',
                            color: theme.gold,
                            fontWeight: 'bolder'
                        }}>
                            {playerStats.balance.toFixed(3)} SOL
                        </div>
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '17px'
                }}>
                    <Star size={isMobile ? 40 : 50} style={{ color: theme.text }} />
                    <div>
                        <div style={{
                            fontSize: isMobile ? '16px' : '18px',
                            color: theme.text,
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                        }}>
                            Level {playerStats.level}
                        </div>
                        <div style={{
                            fontSize: isMobile ? '18px' : '22px',
                            color: theme.gold,
                            fontWeight: 'bold'
                        }}>
                            {playerStats.xp} / {playerStats.level * 100} XP
                        </div>
                        <div style={{
                            width: '100%',
                            height: '8px',
                            backgroundColor: theme.accentDim,
                            borderRadius: '4px',
                            marginTop: '8px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: `${(playerStats.xp / (playerStats.level * 100)) * 100}%`,
                                height: '100%',
                                backgroundColor: theme.gold,
                                transition: 'width 0.3s ease'
                            }} />
                        </div>
                    </div>
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                gap: isMobile ? '12px' : '17px',
                marginTop: isMobile ? '17px' : '26px',
                borderTop: `3px solid ${theme.text}`,
                paddingTop: isMobile ? '17px' : '26px'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: isMobile ? '24px' : '32px',
                        color: theme.gold,
                        fontWeight: 'bolder'
                    }}>
                        {playerStats.total_auctions_won}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: theme.text,
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }}>
                        Auctions Won
                    </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: isMobile ? '24px' : '32px',
                        color: theme.gold,
                        fontWeight: 'bolder'
                    }}>
                        {playerStats.total_bids_placed}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: theme.text,
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }}>
                        Total Bids
                    </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: isMobile ? '24px' : '32px',
                        color: theme.gold,
                        fontWeight: 'bolder'
                    }}>
                        {playerStats.total_auctions_participated > 0
                            ? ((playerStats.total_auctions_won / playerStats.total_auctions_participated) * 100).toFixed(1)
                            : '0.0'}%
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: theme.text,
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }}>
                        Win Rate
                    </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        fontSize: isMobile ? '24px' : '32px',
                        color: theme.gold,
                        fontWeight: 'bolder'
                    }}>
                        {playerStats.achievements?.length || 0}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: theme.text,
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }}>
                        Achievements
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerStats;
